document.addEventListener('DOMContentLoaded', () => {

  // Variables
  const headerSearchContainer = document.querySelector('[data-header-search-container]')
  const headerSearchInput = document.querySelector('[data-header-search-input]')
  const headerSearchScrollIcon = document.querySelector('[data-header-search-scroll-button]')

  // No Results Mobile
  function initMobileNoResultsCarousel(wrapper) {
    //const swiperInitialized = wrapper.classList.contains('swiper-initialized')
    const swiperInstance = new Swiper(wrapper, {
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 20
    })
  }

  // Results
  function searchResultsDropdownChanges(container) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {

        const MOBILE_EMPTY_DIV = 'div#snize-ac-close-area.snize-close-area.snize-hidden'
        if (mutation.target.matches(MOBILE_EMPTY_DIV)) {
          const mobileEmptyStateCarousel = container.querySelector('.header-search-empty-state-mobile-carousel')
          if (mobileEmptyStateCarousel) initMobileNoResultsCarousel(mobileEmptyStateCarousel)
        }

        if (mutation.target === container) {


          setTimeout(function() {

            const resultsColumns = container.querySelector('.snize-ac-results-columns')
            const viewAllBtnContainer = container.querySelector('.snize-ac-results-list.snize-view-all-container')
            if (resultsColumns && viewAllBtnContainer) resultsColumns.appendChild(viewAllBtnContainer)

            const searchDropSuggestionTitle = container.querySelector('#snize-ac-items-container-1 .snize-label')
            const searchDropBrandsTitle = container.querySelector('#snize-ac-items-container-2 .snize-label')
            const searchDropArticlesTitle = container.querySelector('#snize-ac-items-container-3 .snize-label')
            if (searchDropSuggestionTitle) searchDropSuggestionTitle.innerHTML = 'Suggestions'
            if (searchDropBrandsTitle) searchDropBrandsTitle.innerHTML = 'Brands'
            if (searchDropArticlesTitle) searchDropArticlesTitle.innerHTML = 'Articles'
            const viewAllLink = container.querySelector('.snize-view-all-link')
            const viewAllLinkCount = viewAllLink?.querySelector('span')
            const viewAllLinkTextContent = viewAllLinkCount?.textContent
            const searchDropProductsTitle = container.querySelector('#snize-ac-items-container-4 .snize-label')
            if (viewAllLinkTextContent && searchDropProductsTitle) {
              const viewAllLinkCountNumber = parseInt(viewAllLinkTextContent.match(/\d+/)[0], 10)
              searchDropProductsTitle.innerHTML = `Products (${viewAllLinkCountNumber})`
              viewAllLink.innerHTML = 'VIEW ALL RESULTS'
            }

            const searchForm = headerSearchInput.parentElement

            if (searchForm) {
              searchForm.action = '/search'

              searchForm.addEventListener('submit', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                const formInput = document.querySelector('.header__search-input')
                let query = formInput.value

                if (!query) {
                  const secondInput = document.querySelector('.page-search-results-header-form-input')
                  if (secondInput) {
                    query = secondInput.value
                  }
                }

                if (!query) {
                  const mobileInput = document.getElementById('snize-mobile-search-input')
                  if (mobileInput) {
                    query = mobileInput.value
                  }
                }

                window.location = '/search?q=' + encodeURIComponent(query)

                return false;
              })
            }

            viewAllLink && viewAllLink.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopImmediatePropagation();

              const formInput = document.querySelector('.header__search-input')
              let query = formInput.value

              if (!query) {
                const secondInput = document.querySelector('.page-search-results-header-form-input')
                if (secondInput) {
                  query = secondInput.value
                }
              }

              if (!query) {
                const mobileInput = document.getElementById('snize-mobile-search-input')
                if (mobileInput) {
                  query = mobileInput.value
                }
              }
              
              window.location = '/search?q=' + encodeURIComponent(query)

              return false;
            })

            const mobileEmptyStateCarousel = container.querySelector('.header-search-empty-state-mobile-carousel')
            if (mobileEmptyStateCarousel) initMobileNoResultsCarousel(mobileEmptyStateCarousel)

            const firstSuggestionDiv = container.querySelector('#snize-ac-items-container-1')
            const resultsEmptyStateDiv = container.querySelector('.header-search-empty-state')
            if (firstSuggestionDiv && !resultsEmptyStateDiv) {
              firstSuggestionDiv.style.display = "block"
            }
            if (resultsEmptyStateDiv) {
              firstSuggestionDiv.style.display = "none"
            }

            const mobileInput = document.getElementById('snize-mobile-search-input');
            mobileInput && mobileInput.addEventListener('input', function() {
              if (mobileInput.value == "") {
                firstSuggestionDiv.style.display = "none"
              }
            })

          }, 200)

        }
      }
    })
    const observerConfig = { attributes: true, childList: true, subtree: true }
    observer.observe(container, observerConfig)
  }
  function searchDropdownResultsListener() {
      const searchDropObserver = new MutationObserver(() => {
          const resultsDropDownDiv = document.querySelector('.snize-ac-results')
          if (resultsDropDownDiv) {
              searchResultsDropdownChanges(resultsDropDownDiv)
              searchDropObserver.disconnect()
          }
      })
      searchDropObserver.observe(document.body, { childList: true, subtree: true })
  }


  // Default State
  function headerSearchDefaultState() {
    document.body.classList.add('body-noscroll')
    const headerMainMenuContainer = document.querySelector('[data-header-main-menu-container]')
    headerMainMenuContainer && headerMainMenuContainer.classList.add('header-main-menu-container-search-opened')
    // Chat Link
    const headerChatLink = document.querySelector('[data-header-chat-link]')
    headerChatLink && headerChatLink.classList.add('header-chat-link-search-opened')
    // Icons
    const headerIcons = document.querySelector('[data-header-icons]')
    headerIcons && headerIcons.classList.add('header-icons-search-opened')
    //Cancel Button
    const defaultStateSearchCancelButton = document.querySelector('.header-search-close-button')
    defaultStateSearchCancelButton && defaultStateSearchCancelButton.classList.add('header-search-close-button-active')
    // Mask
    const defaultStateSearchMaskDiv = document.querySelector('.header-search-empty-state-mask')
    if (!defaultStateSearchMaskDiv) {
        const defaultStateSearchMaskHTML = `<div class='header-search-empty-state-mask'></div>`
        document.body.insertAdjacentHTML('beforeend', defaultStateSearchMaskHTML)
    }
    // Search Input
    const headerSearchInputWrapper = document.querySelector('.header__search-box')
    headerSearchInputWrapper && headerSearchInputWrapper.classList.add('header__search-box-active')
  }
  function resetHeaderSearchDefaultState() {
    document.body.classList.remove('body-noscroll')
    const headerMainMenuContainer = document.querySelector('[data-header-main-menu-container]')
    headerMainMenuContainer && headerMainMenuContainer.classList.remove('header-main-menu-container-search-opened')
    // Chat Link
    const headerChatLink = document.querySelector('[data-header-chat-link]')
    headerChatLink && headerChatLink.classList.remove('header-chat-link-search-opened')
    // Icons
    const headerIcons = document.querySelector('[data-header-icons]')
    headerIcons && headerIcons.classList.remove('header-icons-search-opened')
    // Mask
    const defaultStateSearchMaskDiv = document.querySelector('.header-search-empty-state-mask')
    defaultStateSearchMaskDiv && defaultStateSearchMaskDiv.remove()
    // Cancel Button
    const defaultStateSearchButtonTag = document.querySelector('.header-search-close-button')
    defaultStateSearchButtonTag && defaultStateSearchButtonTag.classList.remove('header-search-close-button-active')
    // Search Input
    const headerSearchInputWrapper = document.querySelector('.header__search-box')
    headerSearchInputWrapper && headerSearchInputWrapper.classList.remove('header__search-box-active')
  }

  // Click on the search input
  if (headerSearchInput) {
      headerSearchInput.addEventListener('click', () => { headerSearchDefaultState() })
      headerSearchInput.addEventListener('keydown', (event) => {
        headerSearchDefaultState()
        if (event.key === 'Escape') { resetHeaderSearchDefaultState() }
      })
  }

  // Reset Header State
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.snize-ac-results')) { resetHeaderSearchDefaultState() }
  })

  headerSearchScrollIcon && headerSearchScrollIcon.addEventListener('click', (event) => {
    if (headerSearchContainer) {
      headerSearchContainer.classList.add('search-active')
      searchDropdownResultsListener()
    }
  })

  // Dropdown results listeners
  if (headerSearchContainer) searchDropdownResultsListener()

})